import React from 'react'
import Routing from './routes/Routing'
import { Provider } from 'react-redux'
import store from './store'

const App = () => {
  return (
    <Provider store={store}>
      <Routing />
    </Provider>
  )
}

export default App